var SymTracRedirect = function () {
	var el = {};
	var iphone = "iPhone";
	var ipod = "iPod";
	var ipad = "iPad";
	var android = "Android";
	var redirectUrl = null;

	var setRedirectUrl = function () {
		if (el.device === iphone || el.device === ipod || el.device === ipad) {
			redirectUrl = el.appStoreUrl;
		} else if (el.device === android) {
			redirectUrl = el.googlePlayUrl;
		} else {
			redirectUrl = undefined;
		}
	};

	var init = function () {

		el = {
			device: $('span.js-hidden.js-device-name').html(),
			googlePlayUrl: $('span.js-device-google-url').html(),
			appStoreUrl: $('span.js-device-app-url').html(),
		};

		setRedirectUrl();

		if (redirectUrl) {
			window.location.href = redirectUrl;
		}
	};

	return {
		init: init
	};
}();

UL.register(SymTracRedirect);
